import React, { useState } from "react";
import { connect } from "react-redux";
import { cancelEvent } from "../../../actions/admin/scheduled-event-actions";
import { Row, Col, Modal, ModalBody, Input, Button } from "reactstrap";
import Loader from "../../../components/Loader/Loader";
import { notification } from "../../../utils/utility";

const CancelModal = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [reason, setReason] = useState("");

  /**
   * on cancel event
   */
  const onCancel = () => {
    const { cancelEvent, handleClose, handleViewDetailClose, loadBookings } =
      props;

    setIsLoading(true);
    cancelEvent({
      data: {
        booking_id: props.data.id,
        cancellation_reason: reason,
      },
      onSuccess: function (response) {
        console.log(response);
        setIsLoading(false);
        notification.success("Event is successfully canceled");
        handleClose();
        handleViewDetailClose();
        loadBookings();
      },
      onError: function (error) {
        console.error(error);
        setIsLoading(false);
      },
    });
  };

  return (
    <>
      <Loader isShowLoader={isLoading} />
      <Modal
        isOpen={props.showCancelModal}
        toggle={props.handleClose}
        className="modal-dialog"
      >
        <ModalBody>
          <div className="">
            <div className="box_content">
              <div className="rd_inputselectheadermodalsetting">
                <button
                  className="rd_colsebtn"
                  onClick={props.handleClose}
                ></button>
              </div>

              <h5 className="rd_modalheadertext rd_modalheadertextnm">
                Cancel Event
              </h5>
              <Row>
                <Col lg="12" className="text-center">
                  <div className="vd-description pl-3 pt-1 pb-3">
                    {props.data ? props.data.invitee : null}
                  </div>
                </Col>
                <Col lg="12" className="text-center">
                  <div className="vd-description pl-3 pt-1 pb-3">
                    {props.data
                      ? `${props.data.when}   ${props.data.start_time}-${props.data.end_time}`
                      : null}
                  </div>
                </Col>

                <Col lg="12" className="text-center">
                  <div
                    className="vd-description pl-3 pt-1 pb-3"
                    style={{ lineHeight: "1.2" }}
                  >
                    Please confirm that you would like to cancel this event. A
                    cancellation email will also go out to the invitee.
                  </div>
                </Col>

                <Col lg={{ size: 10, offset: 1 }} className="text-center">
                  <Input
                    type="textarea"
                    className="form-control"
                    name="reason"
                    placeholder="Reason"
                    onChange={({ target }) => {
                      const { value } = target || {};
                      setReason(value);
                    }}
                  />
                </Col>

                <Col lg={{ size: 5, offset: 1 }} className="mt-4">
                  <Button
                    className="btn btn-danger"
                    type="button"
                    onClick={props.handleClose}
                  >
                    No, don't cancel
                  </Button>
                </Col>

                <Col lg="5" className="mt-4">
                  <Button
                    type="submit"
                    className="btn btn-app"
                    onClick={onCancel}
                  >
                    Yes, cancel
                  </Button>
                </Col>
              </Row>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default connect(null, {
  cancelEvent,
})(CancelModal);
